// extracted by mini-css-extract-plugin
export default {"a":"text_a__HonRt"};